// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PROFILE_username_BLOCKED_BY_USER = "Pou\u017e\u00edvate\u013eka %(username)s u\u017e nem\u00e1 \u00fa\u010det na Modrom kon\u00edku. K tomuto kroku sa rozhodla sama pou\u017e\u00edvate\u013eka.";
